import './Usermenu.css'
import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useUser } from '../context/UserContext'

export default function UserMenu() {
  const { user, openAuth, logout } = useUser()
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  // click outside or press Escape to close the dropdown
  useEffect(() => {
    if (!open) return
    const off = e => { if (!ref.current?.contains(e.target)) setOpen(false) }
    const esc = e => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('mousedown', off)
    document.addEventListener('keydown', esc)
    return () => {
      document.removeEventListener('mousedown', off)
      document.removeEventListener('keydown', esc)
    }
  }, [open])

  if (!user) return <button className="btn btn--sm um__in" onClick={openAuth}>Sign in</button>

  const name = user.name || 'Account'
  return (
    <div className="um" ref={ref}>
      <button className="um__btn" aria-expanded={open} aria-haspopup="true" onClick={() => setOpen(o => !o)}>
        <span className="um__av" aria-hidden="true">{name.charAt(0).toUpperCase()}</span>
        <span className="um__name">{name.split(' ')[0]}</span>
        <span className="um__caret" aria-hidden="true">▾</span>
      </button>
      {open && (
        <div className="um__pop">
          <strong>{name}</strong>
          <small>{user.email}</small>
          {user.phone && <small>+91 {user.phone}</small>}
          <Link className="um__link" to="/orders" onClick={() => setOpen(false)}>My orders</Link>
          <button className="btn btn--sm" onClick={() => { logout(); setOpen(false) }}>Sign out</button>
        </div>
      )}
    </div>
  )
}